"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var defaultCommit = {
  type: _constants.DEFAULT_COMMIT
};
var _default = defaultCommit;
exports.default = _default;